import { Box } from '@breathelife/mui';
import styled from '../../../../Styles/themed-styled-components';

export const ListContainer = styled(Box)`
  background-color: ${(props) => props.theme.colors.grey[10]};
  overflow-y: auto;
`;
